import { Dialog } from "@mui/material";
import { styled } from "styled-components";

export const CustomConfirmationDialog = styled(Dialog)`
    .MuiPaper-root {
        display: flex;
        filter: drop-shadow(4px 8px 64px hsla(291deg, 50%, 19%, 0.5));
    }
    
    .MuiDialogContent-root {
        width: 75%;
        text-align: center;
        align-self: center;
    }
`